module.exports = __webpack_public_path__ + "img/E2 DB2.073fcb49.png";